import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tree_view = _resolveComponent("tree-view")!

  return (_openBlock(), _createBlock(_component_tree_view, {
    id: "sparepartTypeTree",
    size: "medium",
    "data-items": _ctx.treeDataItems,
    "expand-icons": false,
    item: "itemCell",
    onExpandchange: _ctx.onExpandChange,
    onItemclick: _ctx.onSelect
  }, {
    itemCell: _withCtx(({props}) => [
      _createElementVNode("span", {
        style: _normalizeStyle(props.item.expanded ? { fontWeight: 'bold' } : { })
      }, _toDisplayString(props.item.text), 5)
    ]),
    _: 1
  }, 8, ["data-items", "onExpandchange", "onItemclick"]))
}